import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import PlaceBidModal from '../../../../../../components/PlaceBidModal/PlaceBidModal';
import moment from "moment";
import { useSelector } from 'react-redux';


const PlaceBidCard = () => {
    const [placebidModal, setplacebidModal] = useState(true);
    const [editModal, setEditModal] = useState(false);
    const propsData = useSelector((state) => state.favoritesReducer.placeBidData)
    const location = useLocation();
    const EditBidFunction = (value) => {
        setplacebidModal(value);
        setEditModal(true);
    }

    const { SkillListingCard, cardDetails, professionCode, candidateList, bidUpdateSuccess,  } = location?.state;
    return (
        <div>
                <PlaceBidModal
                    visible={placebidModal}
                    cardDetails={cardDetails}
                    placeBidModalVisisblityHandler={EditBidFunction}
                selectedCandidates={candidateList ? candidateList : propsData?.selectedCandidates}
                    EditBid={true}
                    multiBid={false}
                    rate_flag={true}
                    Bid_rate={
                        cardDetails?.Rate ??
                        cardDetails?.Rate?.$numberDecimal ??
                        bidUpdateSuccess?.Rate ??
                        bidUpdateSuccess?.Rate?.$numberDecimal
                    }
                    IdealConLength={cardDetails?.IdealTerm ?? bidUpdateSuccess?.IdealTerm}
                    SkillListingId={SkillListingCard?.SkillListingId}
                    Description={cardDetails?.Comments ?? bidUpdateSuccess?.Comments}
                    IdealStartDate={
                        cardDetails?.IdealStartDate
                            ? moment(cardDetails?.IdealStartDate).format("MMMM DD, YYYY")
                            : "N/A"
                    }
                    BidId={cardDetails?.BidId}
                    desired_rate={
                        professionCode?.Professions?.ProfessionCode !== "IT" ?
                            Math.floor(SkillListingCard?.MinimumBid?.$numberDecimal)
                                ? Math.floor(SkillListingCard?.MinimumBid?.$numberDecimal)
                                : Math.floor(SkillListingCard?.MinimumBid) :
                            SkillListingCard?.ClientRate?.$numberDecimal
                                ? parseFloat(SkillListingCard?.ClientRate?.$numberDecimal)
                                : SkillListingCard?.ClientRate
                    }
                    frompdetail={true}
                    rateType={cardDetails?.BudgetTypeId ?? bidUpdateSuccess?.BudgetTypeId}
                    Title="Edit bid"
                />
        </div>
    );
};

export default PlaceBidCard;